import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

type Props = {
  title: string,
  body: string,
  imageName: string | undefined | null,
  qa: string,
  overrides: {
    imageSize: 'normal' | 'small'
  },
  extras: {
    date: string,
    slideModificator?: string
  }
};

class TutorialCarouselSlideGeneric extends React.PureComponent<Props> {
  static defaultProps = {
    overrides: {
      imageSize: 'normal'
    },
    extras: {
      date: ''
    }
  };

  render(): React.ReactNode {
    const { title, body, imageName, overrides, extras, qa } = this.props;

    const slideClasses = classnames({
      'tutorial-carousel-slide-generic': true,
      [`tutorial-carousel-slide-generic--${extras.slideModificator}`]: !isNil(extras.slideModificator)
    });
    const imageClasses = classnames({
      'tutorial-carousel-slide-generic__image': true,
      [`tutorial-carousel-slide-generic__image--size-${overrides.imageSize}`]: overrides.imageSize
    });

    return (
      <section
        className={slideClasses}
        data-qa={qa}
      >
        <div className="tutorial-carousel-slide-generic__image-wrapper">
          <img
            className={imageClasses}
            src={`/static/images/${String(imageName)}.png`}
            alt=""
          />
          {
            extras.date &&
              <div className="tutorial-carousel-slide-generic__date">
                {extras.date}
              </div>
          }
        </div>
        <div className="tutorial-carousel-slide-generic__title">
          {title}
        </div>
        <div className="tutorial-carousel-slide-generic__body">
          {body}
        </div>
      </section>
    );
  }
}

export default TutorialCarouselSlideGeneric;
